import React, {useEffect, useState } from 'react';
import { Row, Space,Button,Modal,Col } from 'antd';
import { FormProps } from '../../utility/types';
import { useForm } from '../../utility/useForm';
import { NoValidateForm } from '../../utility/validationRules';
import { ValidationErrorSpan } from '../../styles/global';
import { errorNotify, sucessNotify } from '../../services/toast.notification';
import { InsertMachineNote, sendCable } from '../../api/api';
import FormContainer from '../../components/FormContainer/FormContainer';
import CustomTextArea from '../../components/_common/CustomTextArea';
import { useAppSelector } from '../../redux/store/storehooks';


export const NewMachineInstallationHintDialog: React.FC<FormProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog}) => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(NoValidateForm) as any
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const myStore = useAppSelector((state) => state)

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect( ()=>{
    },)

    const onSubmitForm = (e:any) => {
        e.preventDefault();
  
        setIsSubmiting(true)

        InsertMachineNote(
            Number(payLoad.machineId),
            myStore.auth.userId || 0,
            values.description
        )
        .then((result:any) => {
            sucessNotify("اطلاعات با موفقیت ذخیره شده",undefined,5000)
            setIsSubmiting(false)
            onCancel();
        })
        .catch((error) => {
          setIsSubmiting(false)
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

        
    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                <FormContainer title="ثبت توضیحات نصب دستگاه" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading}  isSubmiting={isSubmiting} >
                    <Row>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <CustomTextArea
                                name="description"
                                placeholder="توضیحات (شامل نکات آموزشی جهت نصب دستگاه)"
                                value={values.description || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="description" />
                        </Col>
                    </Row>

                </FormContainer>
            </>
            
        </Modal>
    )
}